import { flexRender } from "@tanstack/react-table";
import { Heading, TypographyColor, TypographyType } from "../typography/Heading";
import { SORT_OPTIONS } from "../../constants";

export const VirtuosoTableHeader = ({
	table,
	headerRowStyle,
	headerCellStyle,
	tableConfig,
}: {
	table: any;
	headerRowStyle?: React.CSSProperties;
	headerCellStyle?: React.CSSProperties | ((header: any) => React.CSSProperties);
	tableConfig: any;
}) => (
	<>
		{table.getHeaderGroups().map((headerGroup: any) => (
			<tr key={headerGroup.id} style={headerRowStyle}>
				{headerGroup.headers.map((header: any, index: number) => {
					const appliedStyle =
						typeof headerCellStyle === "function"
							? headerCellStyle(header)
							: headerCellStyle;

					const isPrimary =
						tableConfig?.PRIMARY_KEY &&
						header.column.id === tableConfig?.PRIMARY_KEY;
					const stickyIndices = tableConfig?.PINNED_ROW_INDICES ?? [];
					const isPinned = stickyIndices.includes(index);

					const baseWidth = header.getSize();
					const adjustedWidth = isPrimary ? baseWidth * 1.5 : baseWidth;

					return (
						<th
							key={header.id}
							colSpan={header.colSpan}
							className={`padding-left-right-5 ${isPinned ? "position-sticky left-0 z-index-3" : ""}`}
							style={{
								...appliedStyle,
								minWidth: adjustedWidth,
								left: isPinned ? `${header.column.getStart("left")}px` : undefined,
								boxShadow: isPinned && table?.getRowModel()?.length > 0 ? `2px 0px 4px rgba(0, 0, 0, 0.1)` : '',

							}}
						>
							{header.isPlaceholder ? null : (
								<div
									className="d-flex align-items-center justify-content-between gap-1 h-100"
									style={{
										userSelect: "none",
										minWidth: "fit-content",
									}}
								>
									<Heading
										title={flexRender(header.column.columnDef.header, header.getContext())}
										colour={TypographyColor.primary}
										type={TypographyType.h5}
										classname="margin-top-bottom-0 align-middle"
										style={{ whiteSpace: "nowrap" }}
									/>

									{header.column.getCanSort() && (
										<span className="d-flex flex-column" style={{ flexShrink: 0 }}>
											{SORT_OPTIONS.map(({ dir, icon }) => (
												<span
													key={dir}
													className="material-symbols-outlined fs-14"
													style={{
														color:
															header.column.getIsSorted() === dir
																? "black"
																: "#999",
														cursor: "pointer",
													}}
													onClick={() =>
														header.column.toggleSorting(dir === "desc")
													}
												>
													{icon}
												</span>
											))}
										</span>
									)}
								</div>
							)}
						</th>
					);
				})}
			</tr>
		))}
	</>
);
